import type {
  AddErrorMessage,
  MessageDictionary,
} from 'pages/AutomationEngine/messageDictionary';
import { LoopValues } from '../types';
import { ApiVariable } from 'pages/AutomationEngine/dialogs/ActionWizard/helpers';
import { AUTOMATION_STEPS } from 'pages/AutomationEngine/steps';

const forApi = (step: { details: LoopValues }) => {
  const { type, loopType, forEachItem } = step.details ?? ({} as LoopValues);
  const arrayVariable = forEachItem?.arrayVariable ?? null;
  const itemVariable = forEachItem?.itemVariable ?? null;

  // loopType belongs inside stepLoop, not beside it. stepForApi already emits a
  // `step_loop` key (prefix 'step' + type 'loop'), and camelToSnakeCaseKeys maps
  // this `stepLoop` onto the same key - the later one wins - so anything left at
  // the root is dropped from what persists. forFlow reads loopType back out of
  // step_loop, so writing it anywhere else breaks the round trip.
  const ret = {
    type,
    stepLoop: {
      loopType,
      arrayVariable: arrayVariable?.value ?? arrayVariable?.label ?? null,
      itemVariable,
    },
  };

  return ret;
};

type ForFlowApiObject = {
  loopType: string;
  arrayVariable: ApiVariable;
  itemVariable: ApiVariable;
};

const forFlow = (
  apiObject: ForFlowApiObject,
  addErrorMessage: AddErrorMessage,
  messageDictionary: MessageDictionary
) => {
  const { loopType, arrayVariable, itemVariable } = apiObject;

  // A loop with no array left to iterate is broken, so the step is surfaced in
  // error on load the same way an in-session deletion flags it.
  if (arrayVariable?.deleted) {
    addErrorMessage(messageDictionary.loopArrayVariableDeleted);
  }

  const details = {
    type: AUTOMATION_STEPS.loop.type,
    loopType,
    forEachItem: {
      arrayVariable: {
        label: arrayVariable.deleted
          ? `${arrayVariable.name} ${messageDictionary.deleted}`
          : arrayVariable.name,
        value: arrayVariable.name,
        deleted: arrayVariable.deleted,
        meta: arrayVariable,
      },
      itemVariable: itemVariable.name,
    },
  };
  return details;
};

export const stepLoopDTO = {
  forApi,
  forFlow,
};
